export default function authHeader () {

 
    return { token: "GP7766733LMOQW122222"} // for Spring Boot back-end
  
}
